import { useActivateCampaignMutation } from 'modules/campaigns/lib';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { useGenerateCampaignAlerts } from '../../hooks';
import { maybeRestErrorMessage } from '../../utils';
import { getActivateCampaignPayload } from './ActivateCampaignModal.utils';

export const useActivateCampaign = () => {
  const { closeModal } = useModalContext();
  const { isLoading, mutate, error } = useActivateCampaignMutation();
  const { generateCampaignAlerts } = useGenerateCampaignAlerts();

  const dispatch = useDispatch();

  const { campaign, refetch: refetchCampaign } = useCampaignContext();
  const { name, id, campaignAlertsEnabled } = campaign;

  const activateCampaign = () => {
    const onSuccess = () => {
      dispatch(addPositiveToast(`${name} activated successfully.`));
      generateCampaignAlerts({ campaignAlertsEnabled, id });
      closeModal(ModalType.ActivateCampaignModal);
      refetchCampaign();
    };

    const onError = (e: any) => {
      const errorResponseMessage = maybeRestErrorMessage(e);
      const defaultErrorMessage = 'Error activating campaign: something went wrong.';
      const errorMessage = errorResponseMessage || defaultErrorMessage;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'activateCampaign', e));
    };

    const payload = getActivateCampaignPayload(campaign);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, activateCampaign };
};
